document.addEventListener("DOMContentLoaded", function() {
    function updateSlideshowImages() {
        document.querySelectorAll(".slideshow__image").forEach(function(img) {
            let mobileSrc = img.getAttribute("data-mobile-src");
            let desktopSrc = img.getAttribute("data-desktop-src");

            if (mobileSrc && window.innerWidth < 750) {
                img.setAttribute("src", mobileSrc);
            } else if (desktopSrc) {
                img.setAttribute("src", desktopSrc);
            }
        });
    }

    // Executa a troca ao carregar a página
    updateSlideshowImages();

    // Atualiza as imagens ao redimensionar a tela
    window.addEventListener("resize", updateSlideshowImages);
});